import styled from "styled-components"
import { Button } from "@quorumus/plum"

export const menuStyles = {
    dropdown: {
        width: "130px",
        "--Label-Large-Size": "10px",
        "mantine-Menu-itemSection i": {
            "font-size": "12px !important",
        },
    },
}

export const menuItemStyles = {
    item: {
        "--Label-Large-Size": "12px",
    },
}

export const buttonStyles = {
    root: {
        "font-size": "14px !important",
    },
}

export const ButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: var(--plum-spacing-xs);

    @media (max-width: 768px) {
        width: 100%;
    }
`

const BaseButton = styled(Button)`
    background-color: var(--organization-primary-color-5);
    border-color: var(--plum-gray-5);
    font-size: 14px !important;
    height: 30px !important;

    span,
    i,
    svg {
        color: var(--contrasted-organization-primary-color-5);
    }

    &:hover {
        background-color: var(--organization-primary-color-7) !important;
        border-color: var(--organization-primary-color-9) !important;
    }

    &:focus {
        box-shadow: 0 0 0 1px solid var(--plum-black) !important;
        outline: 1px solid var(--plum-black) !important;
        border-color: var(--plum-black) !important;
        outline-offset: 2px !important;
        background-color: var(--organization-primary-color-7) !important;
        border-color: var(--organization-primary-color-9) !important;
    }

    @media (max-width: 768px) {
        flex: 1 1 0;
        justify-content: center;
    }
`

export const MenuButton = styled(BaseButton)``

export const DownloadButton = styled(BaseButton)``
